import React from 'react';

const CodeReportPage = () => {
  return (
    <div className="code-report-page">
      <h1>Report a private property issue</h1>
      <p>This is a placeholder for the code enforcement report form.</p>
    </div>
  );
};

export default CodeReportPage;

